export default __webpack_public_path__ + "static/game_banner-efd2d615b0ee73c3b7582a9a140f5fb9.webp";